import React from "react";
import { useHistory } from "react-router-dom";
import reloadIcon from "../../images/reload.png";
import "./ErrorPages.css";

const ErrorPageLayout = ({
  code,
  title,
  message,
  actionLabel = "Go to Home",
  actionPath = "/",
  actionType = "navigate",
  showReloadIcon = false,
  variant = "default",
}) => {
  const history = useHistory();

  const handleAction = () => {
    if (actionType === "reload") {
      window.location.reload();
      return;
    }

    history.push(actionPath);
  };

  return (
    <div className={`error-page error-page--${variant}`}>
      <div className="error-page__content">
        {code && <p className="error-page__code">{code}</p>}
        <h1 className="error-page__title">{title}</h1>
        <p className="error-page__message">{message}</p>
        <button
          type="button"
          className={`error-page__action${showReloadIcon ? " error-page__action--icon" : ""}`}
          onClick={handleAction}
        >
          {showReloadIcon ? (
            <img src={reloadIcon} alt="" className="error-page__reload-icon" />
          ) : null}
          <span>{actionLabel}</span>
        </button>
      </div>
    </div>
  );
};

export default ErrorPageLayout;
